export default "__VITE_ASSET__JHt8TMj6__"